<script lang="ts">
	import type { EligibleProductsResponse } from '$lib/types/special-sale';
	import { createProductFetcherStore } from '$lib/store/productFetcher.store';
	import ProductBundleRecommendationCartDisplay from '$lib/components/Product/SpecialSale/ProductBundleRecommendationCartDisplay.svelte';
	import { onMount } from 'svelte';
	import { T } from '@tolgee/svelte';

	export let responses: EligibleProductsResponse[];

	$: handles = responses.map((e) => e.handles).flat();
	$: fetcher = createProductFetcherStore(...handles);

	let hasNext = true;
	let hasPrev = false;
	let currentIndex = 0;

	const getResponseForHandle = (handle: string) =>
		responses.find((e) => e.handles.includes(handle));

	$: selectedProduct = $fetcher[currentIndex];
	$: currentSale = getResponseForHandle(selectedProduct?.data?.product?.product?.handle || '');

	let scrollerRef: HTMLDivElement;

	const evaluateControls = () => {
		setTimeout(() => {
			if (!scrollerRef) {
				return;
			}
			hasNext = scrollerRef.scrollLeft + scrollerRef.clientWidth < scrollerRef.scrollWidth - 40;
			hasPrev = scrollerRef.scrollLeft > 50;
			currentIndex = getScrollIndex();
		}, 300);
	};
	const childWidth = () => scrollerRef?.children?.[0]?.getBoundingClientRect().width ?? 0;
	const getScrollIndex = () => Math.round(scrollerRef.scrollLeft / childWidth());

	const next = () => {
		if (!scrollerRef) {
			return;
		}
		scrollerRef.scrollBy({
			left: childWidth(),
			behavior: 'smooth'
		});
		evaluateControls();
	};

	const prev = () => {
		if (!scrollerRef) {
			return;
		}
		scrollerRef?.scrollBy({
			left: -childWidth(),
			behavior: 'smooth'
		});
		evaluateControls();
	};

	onMount(() => {
		evaluateControls();

		scrollerRef.addEventListener('scroll', evaluateControls);
		window.addEventListener('resize', evaluateControls);

		return () => {
			scrollerRef.removeEventListener('scroll', evaluateControls);
		};
	});
</script>

<h4 class="mt-4">
	<T
		keyName="cart.special.sale"
		params={{ sale: `${(currentSale?.discountPercentage ?? 0) * 100}%` }}
	/>
</h4>
<div bind:this={scrollerRef} class="flex overflow-x-auto snap-x snap-mandatory scrollbar-hide">
	{#each $fetcher as { data }}
		{#if data?.product?.product}
			{@const response = getResponseForHandle(data.product.product.handle)}
			<ProductBundleRecommendationCartDisplay sale={response} productData={data.product} />
		{/if}
	{/each}
</div>
<div class="flex justify-center gap-12 my-4">
	<button
		disabled={!hasPrev}
		on:click={prev}
		class="bg-accent-primary disabled:opacity-50 w-6 h-6 grid place-items-center rounded-full hover:bg-white hover:border border-accent-primary group"
	>
		<span class="i-sprenger-chevron-left text-white hover:text-accent-primary w-5 h-5"></span>
	</button>
	<button
		disabled={!hasNext}
		on:click={next}
		class="bg-accent-primary disabled:opacity-50 w-6 h-6 grid place-items-center rounded-full hover:bg-white hover:border border-accent-primary group"
	>
		<span class="i-sprenger-chevron-right text-white hover:text-accent-primary w-5 h-5"></span>
	</button>
</div>
